import React from 'react';
import { EntitlementBaseProduct } from '@atlassian/cssxp-types-entitlement';
import { getNextBillOrEndDate, isFutureDatedInactiveSubscription } from '@css-xp/ppc-utils';
import { isEntitlementOnGracePeriod } from '@css-xp/ppc-utils/src/entitlement-utils';
import {
  getFormattedDate,
  isActiveEntitlement,
  isTrialEntitlement,
  validateFreeSubscriptions,
} from '@css-xp/entitlements-v2';
import { EntitlementDetails, BillingStatus } from '@css-xp/graphtypes/src/generated-types-new';
import { NoData } from '@css-xp/ppc-common';

export const CurrentBillingPeriod = ({
  entitlement,
  showFutureBillingPeriod = false,
  isSupportForManualBillingEnabled,
}: {
  entitlement: EntitlementDetails;
  showFutureBillingPeriod?: boolean;
  isSupportForManualBillingEnabled?: boolean;
}) => {
  const isFutureDatedInactiveEntitlement =
    showFutureBillingPeriod &&
    isFutureDatedInactiveSubscription(
      !!entitlement?.isFutureDatedSubscription,
      entitlement?.billingStatus as BillingStatus
    );

  if (isFutureDatedInactiveEntitlement && entitlement?.futureDatedStartTimestamp && entitlement?.endTimestamp) {
    return (
      <span>
        {getFormattedDate(entitlement?.futureDatedStartTimestamp.toString())}
        {` - `}
        {getFormattedDate(entitlement?.endTimestamp.toString())}
      </span>
    );
  }

  const isActive = isActiveEntitlement(entitlement);
  if (!isActive) {
    return <NoData />;
  }

  const isTrial = isTrialEntitlement(entitlement, entitlement.baseProduct === EntitlementBaseProduct.STATUS_PAGE);
  if (
    isTrial &&
    entitlement.subscriptionTimestamps?.firstTrialStartTimestamp &&
    entitlement.subscriptionTimestamps?.lastTrialEndTimestamp
  ) {
    return (
      <span>
        {getFormattedDate(entitlement.subscriptionTimestamps?.firstTrialStartTimestamp)}
        {` - `}
        {getFormattedDate(entitlement.subscriptionTimestamps?.lastTrialEndTimestamp)}
      </span>
    );
  }

  const { latestPeriodStartDate } = entitlement;
  const isGracePeriodEntitlement = isEntitlementOnGracePeriod(entitlement);
  const nextBillOrEndDate = getNextBillOrEndDate(
    entitlement,
    isSupportForManualBillingEnabled,
    isGracePeriodEntitlement
  );
  const isFree = validateFreeSubscriptions(entitlement);
  if (!isFree && latestPeriodStartDate && nextBillOrEndDate) {
    return (
      <span>
        {getFormattedDate(latestPeriodStartDate)}
        {` - `}
        {getFormattedDate(nextBillOrEndDate)}
      </span>
    );
  }
  return <NoData />;
};
